// extracted by mini-css-extract-plugin
module.exports = {"obj":"ItemObject_obj__2zE9D","img":"ItemObject_img__yZpx3","description":"ItemObject_description__1cUqL","code":"ItemObject_code__1wqO7"};